































































































































































import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';
import CropCreatives from '@/components/campaign/creatives/CropCreatives.vue';
import CreateCreativeFields from '@/components/campaign/creatives/CreateCreativeFields.vue';
import UpdateCreativeFields from '@/components/campaign/creatives/UpdateCreativeFields.vue';
import Button from '@/components/form/Button.vue';
import { CreativeFormat, ICreative } from '@/types/campaign/creatives';
import { sortBy } from 'lodash';
import { getIcon, TIconSvg } from '@/configs/iconsConfigs';
import NotificationService from '@/services/NotificationService';
import { checkCreativeHaveErrors } from '@/helpers/creativeHelpers';
import CreativeService from '@/services/CreativeService';
import { getTranslate } from '@/helpers/translateHelpers';

export default Vue.extend({
  name: 'EditCreatives',
  components: {
    Button,
    CropCreatives,
    CreateCreativeFields,
    UpdateCreativeFields,
  },

  props: {
    ssp: {
      type: Array as PropType<Array<string | number>>,
      required: false,
      default: () => [],
    },
  },

  watch: {
    creativeTemplates() {
      this.loadData = false;
    },
    editCreativeIds(newValue) {
      if (newValue.length) {
        this.modal = true;
      }
    },
  },

  computed: {
    ...mapGetters({
      editCreatives: 'campaignCreatives/getEditCreatives',
      creativeFormats: 'campaignCreatives/getCreativeFormats',
    }),
    refs(): any {
      return this.$refs;
    },
    editCreativeIds(): Array<string> {
      return this.editCreatives?.allIds || [];
    },
    editableCreative(): ICreative {
      return this.editCreatives.byId[
        this.editCreativeIds[this.editableCreativeIndex]
      ];
    },
    sortedCreativeFormats(): Array<CreativeFormat> {
      return sortBy(this.creativeFormats, ['width', 'height']).reverse();
    },
  },

  methods: {
    getIcon(icon: string): TIconSvg {
      return getIcon(icon);
    },
    getTranslate(path: string): string {
      return getTranslate(path);
    },
    apply() {
      if (this.editableCreative.isNew) {
        if (this.refs.createCreatives.validate()) {
          this.refs.createCreatives.apply();
          this.closeModal();
          return;
        }
      } else {
        if (this.refs.updateCreatives.validate()) {
          this.refs.updateCreatives.apply();
          this.closeModal();
          return;
        }
      }

      NotificationService.warning('notifications.creativeIncorrect');
    },
    selectCreativeForEdit(creativeIndex: number) {
      this.editableCreativeIndex = creativeIndex;
    },
    closeModal() {
      this.modal = false;
      this.editableCreativeIndex = 0;
      this.isEditCropCreative = false;
      CreativeService.clearEditCreatives();
    },
    creativeHaveErrors(creativeId: string): boolean {
      return checkCreativeHaveErrors(creativeId);
    },
    toEditCropCreative() {
      this.isEditCropCreative = true;
    },
  },

  data: function () {
    return {
      modal: false,
      editableCreativeIndex: 0 as number,
      isEditCropCreative: false,
      loadData: false,
    };
  },
});
